import React from 'react';

const SecuritiesAccountFormFormModal = React.lazy(() => import('../components/FormModal'));
const securitiesAccountFormModalRegistry = {
    core_securitiesAccountFormId: SecuritiesAccountFormFormModal
};
export default securitiesAccountFormModalRegistry;
